import Client from '../axios-client';

const resource = '/subaccount/subaccounts';

export default {
  getSubaccountsForGrid(parameters) {
    return Client.get(`${resource}` + parameters);
  },
  getSubaccountsForExcel() {
    return Client.get(`${resource}/excel`,
      {
        responseType: 'blob',
        headers: { 'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
      }
    )
  },
  getQuickSearch() {
    return Client.get(`${resource}/quick-search`);
  },
  findSubaccount(subaccountId) {
    return Client.get(`${resource}/${subaccountId}`);
  },
  addSubaccount(payload) {
    return Client.post(`${resource}`, payload);
  },
  changeIdentityData(payload, subaccountId) {
    return Client.put(`${resource}/${subaccountId}/identity`, payload);
  },
  changeAddress(payload, subaccountId) {
    return Client.put(`${resource}/${subaccountId}/address`, payload);
  },
  changeOrganization(payload, subaccountId) {
    return Client.put(`${resource}/${subaccountId}/organization`, payload);
  },
  getPeselDetails(payload) {
    return Client.post(`subaccount/pesel/details`, payload);
  },
  getPeselDetailsInSubaccountContext(payload, subaccountId) {
    return Client.post(`${resource}/${subaccountId}/pesel/details`, payload);
  },
  changePesel(payload, id) {
    return Client.put(`${resource}/${id}/change-pesel`, payload);
  },
  setDeathDate(payload, id) {
    return Client.put(`${resource}/${id}/set-death-date`, payload);
  },
  activateSubaccount(payload, subaccountId) {
    return Client.patch(`${resource}/${subaccountId}/activate`, payload);
  },
  deactivateSubaccount(payload, subaccountId) {
    return Client.patch(`${resource}/${subaccountId}/deactivate`, payload);
  },
  deactivateSentMessage(payload, subaccountId) {
    return Client.patch(`${resource}/${subaccountId}/deactivate-send-message`, payload);
  },
  assignGuardianToSubaccount(payload, subaccountId, guardianId) {
    return Client.patch(`${resource}/${subaccountId}/guardian/${guardianId}/assign`, payload);
  }
};
